import { Button } from '../Button';
import { ButtonWithDropDown } from '../ButtonWithDropDown';
import { IconButtonWithText } from '../IconButtonWithText';

export interface ActionFooterButton {
    text: string;
    onClick: () => void | Promise<void>;
    variant?: 'text' | 'contained' | 'bordered';
    color?: 'blue' | 'error' | 'success';
    className?: string;
    disabled?: boolean;
}

export interface ActionFooterDropdownOption {
    label: string;
    onClick: () => void | Promise<void>;
}

export interface ActionFooterDropdown {
    defaultSelected: ActionFooterDropdownOption;
    options: ActionFooterDropdownOption[];
    dropDirection?: 'up' | 'down';
    variant?: 'text' | 'contained' | 'bordered';
    disabled?: boolean;
}

export interface ActionFooterPreview {
    iconSrc: string;
    iconAlt: string;
    text: string;
    onClick: () => void;
}

export interface ActionFooterProps {
    preview?: ActionFooterPreview;
    buttons?: ActionFooterButton[];
    dropdown?: ActionFooterDropdown;
    className?: string;
}

export const ActionFooter = ({ preview, buttons = [], dropdown, className = '' }: ActionFooterProps) => {
    return (
        <div className={`action-footer ${className}`}>
            <div className="action-footer__actions">
                {buttons.map((button, index) => (
                    <Button
                        key={index}
                        text={button.text}
                        variant={button.variant || 'text'}
                        onClick={button.onClick}
                        color={button.color}
                        disabled={button.disabled}
                    />
                ))}

                {dropdown && (
                    <ButtonWithDropDown
                        dropDirection={dropdown.dropDirection || 'up'}
                        variant={dropdown.variant || 'contained'}
                        type="button"
                        defaultSelected={dropdown.defaultSelected}
                        options={dropdown.options}
                        disabled={dropdown.disabled}
                    />
                )}
            </div>
            {preview && (
                <div className="action-footer__preview">
                    <IconButtonWithText
                        onClick={preview.onClick}
                        iconSrc={preview.iconSrc}
                        iconAlt={preview.iconAlt}
                        variant="text"
                        textColour="blue"
                        text={preview.text}
                    />
                </div>
            )}
        </div>
    );
};
